var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-5 flex justify-center" }, [
    _c(
      "p",
      {
        staticClass:
          "px-2 py-1 border inline-block text-xs font-bold text-gray-800",
      },
      [_vm._v(" " + _vm._s(_vm.separator) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }